<template>
  <v-card class="mt-1">
    <v-card-title v-if="hasSearch || hasCreate">
      <template v-if="hasSearch">
        <slot name="search">
          <search-by ref="search" :datasource="datasource" :attr="searchBy" />
        </slot>
      </template>
      <template v-if="hasCreate">
        <v-btn :to="detailLink('new')" color="primary">{{
          $t('button.new')
        }}</v-btn>
      </template>
      <slot name="extraButton"></slot>
    </v-card-title>

    <slot name="table">
      <datasource-table
        :datasource="datasource"
        @item-selected="selectedItemTraitements"
      />
    </slot>
  </v-card>
</template>

<script>
import Mousetrap from 'mousetrap';

export default {
  props: {
    datasource: {
      type: Object,
      required: true,
    },
    capabilities: {
      type: String,
      default: 'create',
    },
    searchBy: {
      type: String,
      default: 'name',
    },
  },
  computed: {
    hasCreate() {
      return this.hasCapability('create');
    },
    hasSearch() {
      return this.hasCapability('search');
    },
    namespace() {
      return this.datasource.namespace;
    },
  },
  mounted() {
    if (this.$refs.search) {
      this.$refs.search.focus();
    }

    if (this.hasCreate) {
      Mousetrap.bind('shift+n', () => {
        this.$router.push(this.detailLink('new'));
      });
    }
  },
  beforeDestroy() {
    Mousetrap.unbind('shift+n');
  },
  methods: {
    hasCapability(capabilty) {
      return this.capabilities.split(',').includes(capabilty);
    },
    selectedItemTraitements(item) {
      this.$emit('item-selected', item);
    },
    detailLink(id) {
      return {
        name: this.namespace + '/detail',
        params: {
          id,
        },
      };
    },
    refresh() {
      this.datasource.refresh(this.search);
    },
  },
};
</script>
